import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { TenantPaymentReminderSettings } from '~/swagger/settings/Api';

const tenantPaymentReminderUrl = `${envConfig.service.settings}/company-portal/settings/tenantpaymentreminder`;
const tenantPaymentReminderCompanyUrl = `${tenantPaymentReminderUrl}/company`;

export class tenantPaymentReminderRepository extends BaseRestRepository {
  public async getTenantPaymentReminderAll() {
    const url = tenantPaymentReminderUrl + '/with-overrides';
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateTenantPaymentReminder(payload: TenantPaymentReminderSettings) {
    const url = tenantPaymentReminderCompanyUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response, true);
  }

  public async getTenantPaymentReminderByLevel(level: string, levelId: string) {
    const url = `${tenantPaymentReminderUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateTenantPaymentReminderByLevel(level: string, levelId: string, payload: TenantPaymentReminderSettings) {
    const url = tenantPaymentReminderUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response, true);
  }

  public async deleteTenantPaymentReminderByLevel(level: string, levelId: string) {
    const url = `${tenantPaymentReminderUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response, true);
  }
}
